import React, { useState } from "react";
import "./DynamicDetailGrid.css";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";

type DynamicGridProps = {
    columns: number;
    data: { label: any; value: any }[];
    isExpandable?: boolean;
    customClassName?: string;
};

const DynamicAddEditGrid: React.FC<DynamicGridProps> = ({ columns, data, isExpandable = true, customClassName }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const visibleData = isExpandable && !isExpanded ? data.slice(0, 3) : data;

    // Calculate Bootstrap column width (12 grid system)
    const colWidth = Math.floor(12 / columns);

    return (
        <div className={`${customClassName} dynamic-grid bg-white p-3 position-relative`}>
            {/* Chevron Button */}
            {isExpandable && (
                <button
                    className="chevron-button position-absolute top-0 end-0 bg-transparent border-0 cursor-pointer fs-5 mt-2 me-2"
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    <span className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6">
                        {isExpanded ? <ChevronUp /> : <ChevronDown />}
                    </span>
                </button>
            )}

            <div className="row g-3 pb-3">
                {visibleData?.map((item, index) => (
                    <div key={index} className={`col-${colWidth}`}>
                        <div className="grid-item">
                            <label className="grid-label fw-medium d-block mb-1">
                                {item.label}
                            </label>
                            <span className="grid-value font-size-15 fc-dark-blue d-block">
                                {item.value || '-'}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DynamicAddEditGrid;
